<template>
  <div class="container-warp">
    <Top-Nav pageTitle="问卷调查" @click-left="pageBack"></Top-Nav>
    <div class="survey-box" v-show="tipsMessage === ''">
      <div class="survey-title" v-show="surveyTit">{{ surveyTit }}</div>
      <div class="survey-desc" v-show="surveyDesc">
        <van-notice-bar :text="surveyDesc" left-icon="info-o" />
      </div>
      <Survey-form
        :formList="surveyQuestions"
        :surveyId="surveyId"
        @submit="handleSubmitSurvey"
      ></Survey-form>
    </div>

    <!-- 问卷状态 -->
    <div class="survey-state" v-show="tipsMessage !== ''">
      <div class="result">
        <div class="result-icon" :class="resultClassName">
          <van-icon :name="resultIcon" color="#fff" size="38" />
        </div>
        <div class="result-text">{{ tipsMessage }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { surveyDetalis, submitSurvey } from "@/api/survey.js";
import SurveyForm from "./components/survey-form.vue";

export default {
  name: "Survey",
  components: { SurveyForm },
  data() {
    return {
      surveyId: "",
      surveyTit: "问卷标题", // 问卷标题
      surveyDesc: "问卷描述", // 问卷描述
      surveyQuestions: [], // 问卷问题集合
      surveyData: null,
      tipsMessage: "",
      userLocationInfo: {
        longitude: "",
        latitude: "",
      },
    };
  },
  computed: {
    ...mapGetters(["userCode"]),
    resultClassName() {
      const { tipsMessage } = this;
      if (tipsMessage.indexOf("完成") > -1) {
        return "result1";
      } else if (tipsMessage.indexOf("已结束") > -1) {
        return "result0";
      } else if (tipsMessage.indexOf("不能参与") > -1) {
        return "result2";
      } else {
        return "result2";
      }
    },
    resultIcon() {
      const { tipsMessage } = this;
      if (tipsMessage.indexOf("完成") > -1) {
        return "success";
      } else if (tipsMessage.indexOf("已结束") > -1) {
        return "clock-o";
      } else if (tipsMessage.indexOf("不能参与") > -1) {
        return "cross";
      } else {
        return "cross";
      }
    },
  },
  created() {
    const { surveyId = "" } = this.$route.query;
    this.surveyId = surveyId;
  },
  mounted() {
    this.getSurveyDetalis();
  },
  methods: {
    async getSurveyDetalis() {
      const params = {
        userCode: this.userCode,
        surveyId: this.surveyId,
      };
      const { status, data, errors } = await surveyDetalis(params);
      if (status == 200) {
        this.surveyData = JSON.parse(JSON.stringify(data));
        const { content, surveyDes, questions } = data;
        this.surveyTit = content;
        this.surveyDesc = surveyDes;
        this.surveyQuestions = questions;
      } else {
        this.tipsMessage = errors[0].message;
      }
    },
    async handleSubmitSurvey(submitAnswers = []) {
      const params = {
        id: this.surveyId,
        surveyId: this.surveyId || 0,
        userCode: this.userCode,
        longitude: this.userLocationInfo.longitude || 0,
        latitude: this.userLocationInfo.latitude || 0,
        questions: submitAnswers, // 直接使用子组件传来的数据
        visitor:false
      };

      // 提交数据
      const { status } = await submitSurvey(params);
      if (status == 200) {
        this.$toast.success("提交成功");
        setTimeout(() => {
          // this.pageBack();
          // window.close();
         this.$router.replace('/index')
        }, 1500);
      }
    },
  },
};
</script>

<style lang="less" scoped>
.survey-box {
  background-color: #fff;
  padding: 24px 0;
}

.survey-title {
  font-size: 18px;
  font-weight: 600;
  text-align: center;
  padding: 0 18px;
  margin-bottom: 12px;
}

.survey-desc {
  padding: 6px 12px;
}

.survey-state {
  .result {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 80px 6px;
    box-sizing: border-box;

    .result-icon {
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 50%;
      width: 64px;
      height: 64px;

      &.result0 {
        background-color: #2979ff;
      }

      &.result1 {
        background-color: #017a3f;
      }

      &.result2 {
        background-color: #d44f4a;
      }
    }

    .result-text {
      font-size: 18px;
      font-weight: 600;
      margin-top: 6px;
    }
  }
}
</style>
